(function()
{
	"use strict";

	cjs.DisplayObject.prototype.center = function()
	{
		return this.regs(0.5, 0.5);
	};

	cjs.DisplayObject.prototype.setScale = function(scale)
	{
		if (this.scale) {
			this.scale = scale;
		} else {
			this.scaleX = this.scaleY = scale;
		}
		return this;
	};

	cjs.DisplayObject.prototype.hitbox = function(padding, theseBounds)
	{
		var b = this.getBounds();

		// for movieclip components, since sometimes getBounds won't work if the movieclip has no children added yet,
		// and you just want to force some bounds.
		if (theseBounds)
		{
			b = theseBounds;
		}

		if (b)
		{
			padding = padding || 0;
			this.hitArea = new cjs.Shape();
			this.hitArea.graphics.f("#000").r(b.x - padding, b.y - padding, b.width + padding * 2, b.height + padding * 2);
		}

		return this;
	};

	cjs.MovieClip.prototype.changeSnapToPixel = function(snapToPixel)
	{
		function loopChildren(container)
		{
			for(var key in container)
			{
				var prop = container[key];
				if(prop && prop.snapToPixel)
				{
					container[key].snapToPixel = snapToPixel;
					if(container[key].children)
					{
						loopChildren(container[key]);
					}
				}
			}
		}

		loopChildren(this);
	};


	cjs.DisplayObject.prototype.regs = function(rX, rY, absolute) {
		var b = this.getBounds(); 
		var newRegX, newRegY;
		var pctX, pctY;

		if( b !== null ) {
			if(arguments.length === 1) {
				if(typeof arguments[0] === "string") {
					switch(arguments[0]) {
						case "center":
							pctX = pctY = 0.5;
							break;
						default: 
							break;
					}
				} else {
					pctX = pctY = arguments[0];
				}
			} else {
				if(typeof rX === "string") {
					switch (rX) {
						case "center":
							pctX = 0.5;
							break;
						case "left":
							pctX = 0;
							break;
						case "right":
							pctX = 1;
							break;
						default:
							break;
					}
				} else {
					pctX = rX;
				}

				if(typeof rY === "string") {
					switch (rY) {
						case "center":
							pctY = 0.5;
							break;
						case "top":
							pctY = 0;
							break;
						case "bottom":
							pctY = 1;
							break;
						default:
							break;
					}
				} else {
					pctY = rY;
				}

			}


			newRegX = b.width*pctX;
			newRegY = b.height*pctY;

			if (absolute && absolute === true) {
				newRegX = ((typeof rX !== "string") ? rX : b.width*pctX);
				newRegY = ((typeof rY !== "string") ? rY : b.height*pctY);
			}
			this.set({regX: newRegX, regY: newRegY});

			return this;

		} else {
			console.log("Could not set reg points on displayObject, rectangular bounds are not set");
			return this;
		}
	};

	cjs.Bitmap.prototype.getBounds = function() {
		var rect = this.DisplayObject_getBounds();
		if (rect) { return rect; }
		var image = this.image, o = this.sourceRect || image;
		var hasContent = (image && (image.naturalWidth || image.getContext || image.readyState >= 2));
		if (o.naturalWidth) {
			return hasContent ? this._rectangle.setValues(0, 0, o.naturalWidth, o.naturalHeight) : null;
		} else {
			return hasContent ? this._rectangle.setValues(0, 0, o.width, o.height) : null;
		}
	};


	cjs.Rectangle.prototype.contains = function(x, y, width, height) {

		width = width||0;
		height = height||0;

		var that;

		if (arguments[0] instanceof cjs.Rectangle) {
			// it's completely annoying that this didn't take another rectangle instance as an argument, so here it is.
			that = x;
			return (that.x >= this.x && that.x+that.width <= this.x+this.width && that.y >= this.y && that.y+that.height <= this.y+this.height);
		} else {
			return (x >= this.x && x+width <= this.x+this.width && y >= this.y && y+height <= this.y+this.height);
		}
	};

	cjs.MovieClip.prototype.doesHaveLabel = function(labelName) {
		var labels = this.labels;
		for (var l in labels) {
			if (labels[l].label === labelName) {
				return true;
			}
		}
		return false;
	};
})();